var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcehockey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-39.8, -40.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.846,43c-5.514,0-10,2.237-10,4.986c0,2.749,4.486,4.987,10,4.987c5.514,0,10-2.238,10-4.987C59.846,45.237,55.359,43,49.846,43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.846,49.361c-0.987,2.352-5.096,4.12-10,4.12s-9.013-1.768-10-4.12v3.131c0,2.75,4.486,4.986,10,4.986c5.514,0,10-2.236,10-4.986V49.361z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcehockey);
export default __webpack_public_path__ + "static/media/icehockey.0dbd903638e9a5208a2867d933271ca3.svg";
export { ForwardRef as ReactComponent };